export function apexUrl(url: URL) {
    return url.href.replace('://www.', '://');
}

export function startsWithWww(url: URL){
    return url.hostname.startsWith('www.');
}
